var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback } from "react";
/**
returns [refCallback, vtCardTitleCutOffPoint]
 */
export function useGetVTCardTitleCutOffPoint() {
    var _a = __read(useState(16), 2), titleCutOffPoint = _a[0], setTitleCutOffPoint = _a[1];
    var ref = useCallback(function (vtCardExposedRefMethods) {
        if (vtCardExposedRefMethods) {
            new ResizeObserver(function (entries) {
                var _a;
                var cardWidth = (_a = vtCardExposedRefMethods.getRootNode()) === null || _a === void 0 ? void 0 : _a.clientWidth;
                if (cardWidth) {
                    if (cardWidth < 190) {
                        setTitleCutOffPoint(4);
                    }
                    else if (cardWidth < 215) {
                        setTitleCutOffPoint(6);
                    }
                    else if (cardWidth < 250) {
                        setTitleCutOffPoint(8);
                    }
                    else if (cardWidth < 275) {
                        setTitleCutOffPoint(10);
                    }
                    else if (cardWidth < 285) {
                        setTitleCutOffPoint(13);
                    }
                    else if (cardWidth < 300) {
                        setTitleCutOffPoint(15);
                    }
                    else if (cardWidth < 345) {
                        setTitleCutOffPoint(18);
                    }
                    else {
                        setTitleCutOffPoint(18);
                    }
                }
            }).observe(vtCardExposedRefMethods.getRootNode());
        }
    }, []);
    return [ref, titleCutOffPoint];
}
